import sanitizeHtml from "sanitize-html";

export const useRawHTML = (input: string) => {
  return sanitizeHtml(input);
};
